import { defineAsyncComponent } from 'vue'
export default {
  contactus: defineAsyncComponent(() => import("/Users/babythor/Documents/nagase/plastic/layouts/contactus.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/Users/babythor/Documents/nagase/plastic/layouts/default.vue").then(m => m.default || m))
}